<template>
    <div class="main-panel">
        <SearchUser></SearchUser>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import SearchUser from "../components/SearchUsers.vue";

    export default defineComponent({
        components: {
            SearchUser
        },
    });
</script>
